import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import UserProvider from "./context/UserContext";
import Dash from "./pages/Dash";
import {ErrorPage} from  "./pages/Error";
import './main.css'
import 'bootstrap/dist/css/bootstrap.min.css';

export default function App(){
  return (
      <UserProvider>
      <Router>
        <Switch>
          <Route exact path="/" component={Dash} />
          <Route exact path="/error_auth" component={ErrorPage} />
          <Route>
            <Redirect to="/"/>
          </Route>
          </Switch>
      </Router>
      </UserProvider>
  );
};